import React from 'react';
import Tooltip from 'Components/DesignSystem/Tooltip/Tooltip';
import { TagIcon } from 'Components/DesignSystem/Iconography/Icons';
import { CUSTOM_ATTRIBUTE_TAG_TOOLTIP } from 'Common/CustomAttribute';

interface CustomAttributeTagProps {
  /** Stable Playwright hook on the wrapper `span[role="img"]`. */
  'data-testid'?: string;
  /** Glyph size in px. 14 sits well beside 12–14px labels, 16 beside a heading. */
  size?: number;
  className?: string;
}

/**
 * The tag glyph that marks an SME-flagged **custom attribute** (AB#14524 / #13810).
 *
 * One component, every surface: after the name in the Attributes-module list rows
 * and detail header, before the name on both sides of the Data Review comparison grid.
 * Hover / focus shows the DS `Tooltip` with the copy "Custom attribute"; the same copy
 * is the accessible name, so screen readers hear it too.
 */
const CustomAttributeTag = ({ 'data-testid': dataTestId, size = 14, className = '' }: CustomAttributeTagProps) => (
  <Tooltip content={CUSTOM_ATTRIBUTE_TAG_TOOLTIP} placement="top" usePortal>
    <span
      className={`tw-inline-flex tw-shrink-0 tw-items-center tw-text-ink-secondary ${className}`}
      aria-label={CUSTOM_ATTRIBUTE_TAG_TOOLTIP}
      role="img"
      data-testid={dataTestId}
    >
      <TagIcon size={size} aria-hidden="true" />
    </span>
  </Tooltip>
);

export default CustomAttributeTag;
